import { render, staticRenderFns } from "./VesselBlacklistPanel.vue?vue&type=template&id=5707bd18&scoped=true"
import script from "./VesselBlacklistPanel.vue?vue&type=script&lang=js"
export * from "./VesselBlacklistPanel.vue?vue&type=script&lang=js"
import style0 from "./VesselBlacklistPanel.vue?vue&type=style&index=0&id=5707bd18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5707bd18",
  null
  
)

export default component.exports